import { render } from "./BaseIframe.vue?vue&type=template&id=3ce11e8a&scoped=true"
import script from "./BaseIframe.vue?vue&type=script&lang=js"
export * from "./BaseIframe.vue?vue&type=script&lang=js"

import "./BaseIframe.vue?vue&type=style&index=0&id=3ce11e8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ce11e8a"

export default script